import React from 'react'

import { AWSMonitorSelection } from 'components/status-checks/form/status-check/aws/AWSMonitorSelection'
import { DatadogMonitorSelection } from 'components/status-checks/form/status-check/datadog/DatadogMonitorSelection'
import { DynatraceMonitorSelection } from 'components/status-checks/form/status-check/dynatrace/DynatraceMonitorSelection'
import { GrafanaMonitorSelection } from 'components/status-checks/form/status-check/grafana/GrafanaMonitorSelection'
import { PrometheusMonitorSelection } from 'components/status-checks/form/status-check/prometheus/PrometheusMonitorSelection'
import { ObservabilityToolType } from 'types/api/status-checks/status-check'

export const StatusCheckMonitorSelection: React.FC<{
  observabilityToolType: ObservabilityToolType | undefined
}> = ({ observabilityToolType }) => {
  switch (observabilityToolType) {
    case ObservabilityToolType.AWS:
      return <AWSMonitorSelection />
    case ObservabilityToolType.DYNATRACE:
      return <DynatraceMonitorSelection />
    case ObservabilityToolType.GRAFANA:
      return <GrafanaMonitorSelection />
    case ObservabilityToolType.PROMETHEUS:
      return <PrometheusMonitorSelection />
    case ObservabilityToolType.DATADOG:
      return <DatadogMonitorSelection />
    default:
      return null
  }
}
